
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState([
      "asideActiveForcedKey",
      "isAsideExpanded",
      "isAsideMobileExpanded"
    ])
  }
})
export default class AsideMenuItem extends Vue {
  @Prop({ default: null }) private item?: any;
  @Prop({ default: false }) private isSecondary?: boolean;

  // Mapped from vuex
  asideActiveForcedKey!: any;
  isAsideExpanded!: boolean;
  isAsideMobileExpanded!: boolean;

  // Other variables
  isDropdownActive = false;

  // Getters
  get componentIs() {
    return this.item.to ? "router-link" : "a";
  }

  get hasSubmenuIcon() {
    return this.hasDropdown || this.item.menuSecondary;
  }

  get hasDropdown() {
    return !!this.item.menu;
  }

  get submenuIcon() {
    if (this.item.menuSecondary) {
      return "chevron-right";
    }
    return this.isDropdownActive ? "minus" : "plus";
  }

  get itemTo() {
    return this.item.to ? this.item.to : null;
  }

  get itemHref() {
    return this.item.href ? this.item.href : null;
  }

  get componentTitle() {
    return !this.isAsideExpanded && this.item.label ? this.item.label : null;
  }

  get componentClass() {
    const c = {
      "has-icon": !!this.item.icon,
      "has-submenu-icon": this.hasSubmenuIcon
    } as any;

    if (this.item.state) {
      c["is-state-" + this.item.state] = true;
      c["is-hoverable"] = true;
    }

    if (
      this.asideActiveForcedKey &&
      this.item.menuSecondaryKey &&
      this.asideActiveForcedKey === this.item.menuSecondaryKey
    ) {
      c["is-active"] = true;
    }

    return c;
  }

  get componentActiveClass() {
    if (this.asideActiveForcedKey) {
      return null;
    }
    return "is-active";
  }

  // Methods
  menuClick() {
    this.$emit("menu-click", this.item);

    if (this.hasDropdown) {
      this.isDropdownActive = !this.isDropdownActive;

      if (!this.isSecondary && !this.isAsideMobileExpanded) {
        this.$store.commit("asideStateToggle", true);
      }
    }
  }

  // Watchers
  @Watch("isAsideExpanded")
  onIsAsideExpandedChanged(newValue: boolean) {
    if (!newValue) {
      this.isDropdownActive = false;
    }
  }
}
